"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitScreen = void 0;
const react_1 = __importStar(require("react"));
const split_screen_styles_1 = require("./split-screen-styles");
const split_screen_hook_1 = require("./split-screen-hook");
const split_screen_switcher_1 = require("./split-screen-switcher");
exports.SplitScreen = react_1.forwardRef(function SplitScreen({ children, midPoint = 600, leftMinWidth = 0, rightMinWidth = 0, leftLabel, rightLabel, }, ref) {
    const { handleDragStart, leftSize, transitionOn, handleFullSizeLeft, handleFullSizeRight, handleMoveToMiddle, handleMoveLeft, handleMoveRight, isLeftOnFullscreen, isRightOnFullscreen, } = split_screen_hook_1.useSplitScreen({ leftMinWidth, midPoint, rightMinWidth });
    react_1.useImperativeHandle(ref, () => ({
        handleFullSizeLeft,
        handleFullSizeRight,
        handleMoveToMiddle,
        isLeftOnFullscreen,
        isRightOnFullscreen,
    }), [
        handleFullSizeLeft,
        handleFullSizeRight,
        handleMoveToMiddle,
        isLeftOnFullscreen,
        isRightOnFullscreen,
    ]);
    /**
     * Styles
     */
    const classes = split_screen_styles_1.useStyles();
    const commonStyles = {
        overflow: 'auto',
        boxSizing: 'border-box',
        transition: transitionOn ? 'width 0.5s linear' : undefined,
    };
    const leftContainerStyles = {
        ...commonStyles,
        width: `${leftSize}px`,
        minWidth: `${leftMinWidth}px`,
    };
    const rightContainerStyles = {
        ...commonStyles,
        width: `calc(100% - ${leftSize}px)`,
        minWidth: `${rightMinWidth}px`,
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: leftContainerStyles }, children[0]),
        react_1.default.createElement("div", { className: classes.dragger },
            react_1.default.createElement(split_screen_switcher_1.SplitScreenSwitcher, { handleDragStart: handleDragStart, handleLeftClicked: handleMoveLeft, handleRightClicked: handleMoveRight, leftLabel: leftSize < 50 ? leftLabel : '', leftDisabled: leftSize === leftMinWidth, rightLabel: leftSize > window.innerWidth - 50 ? rightLabel : '', rightDisabled: leftSize === window.innerWidth - rightMinWidth })),
        react_1.default.createElement("div", { style: rightContainerStyles }, children[1])));
});
//# sourceMappingURL=split-screen.js.map